import { FC } from 'react'
import { Container } from './payment-checkout.styled'
import { PaymentMethodsMobile } from './payment-methods'

export const PaymentCheckout: FC = () => {
  return (
    <Container>
      <PaymentMethodsMobile />
    </Container>
  )
}
